import { Checkbox, DefaultButton, MessageBar, MessageBarType, Pivot, PivotItem, Spinner, Stack, TextField } from '@fluentui/react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import PersonalSettingsState from '../../../state/PersonalSettingsState';
import { InfoTooltipLabel } from '../../controls/InfoTooltipLabel';

function EmailFilingAdminPage({ state }: { state: PersonalSettingsState }) {

	useEffect(() => {
		state.ensureLoaded();
	}, [state]);

	if(state.loading || !state.settings) {
		return <Spinner />
	}

	return (
		<Stack>
		<Pivot>
			<PivotItem headerText='Server filing'>
						
				<Stack>			
					<InfoTooltipLabel label='Enable server email filing' title='Enables automatic filing of received, tagged mailbox messages.'>
						<Checkbox
							label='Enable filing of messages in a specific mailbox, by extracting a filing tag from subject lines.'
							checked={state.settings.emailFilingEnabled}
							onChange={(_, checked) => { state.updateEmailFilingEnabled(!!checked); }}
						/>
					</InfoTooltipLabel>

					{ state.settings.emailFilingEnabled ? <>


						<InfoTooltipLabel label='Filing Mailbox User' title='User ID whose mailbox will have tagged messages auto filed on receipt, or a shared mailbox email address.'>

							<TextField value={state.settings.emailFilingUserId} onChange={(_, newValue) => state.updateEmailFilingUserId(newValue || '')} />

							{/* If we are using a service account and that account is different from the filing mailbox, show a warning */}
							{(!state.settings.useAppIdentity && !!state.settings.emailFilingUserId && !!state.settings.serviceAccountId && state.settings.serviceAccountId !== state.settings.emailFilingUserId) ? <>
								<MessageBar messageBarType={MessageBarType.warning}>
									The service account user will require access to this filing mailbox. You must grant delegated mailbox access for server filing to work.
									<a rel='noopener noreferrer' href='https://learn.microsoft.com/en-us/microsoft-365/admin/add-users/give-mailbox-permissions-to-another-user?view=o365-worldwide' target='_blank'>Learn more</a>
								</MessageBar>
							</> : <></>}


						</InfoTooltipLabel>

						<InfoTooltipLabel label='Delete on file' title='Enables deletion of a mailbox messages when they have been filed.'>
							<Checkbox
								checked={state.settings.emailFilingDeleteOnFile}
								onChange={(_, checked) => { state.updateEmailFilingDeleteOnFile(!!checked); }}
								label='Enable deletion of filed messages when they have been filed.'
							/>
						</InfoTooltipLabel>

						{/* show a message bar with a button opening the docs link: https://learn.microsoft.com/en-us/exchange/security-and-compliance/mail-flow-rules/mail-flow-rules */}
						<div style={{ marginTop: 20 }}>
							<MessageBar>
								To enable filing of all relevant messages, ensure mail flow rules are configured to route messages to the target inbox via BCC.
								<a rel='noopener noreferrer' href='https://learn.microsoft.com/en-us/exchange/security-and-compliance/mail-flow-rules/mail-flow-rules' target='_blank'>Learn more</a>
							</MessageBar>	
						</div>

					</> : <></> }

				</Stack>
				
			</PivotItem>
			<PivotItem headerText='Attachments'>

				<InfoTooltipLabel label='Prevent file attachments' title={`When enabled, only the "Insert Link" option will be available in Outlook. The "Attach File" option will be hidden, preventing users from attaching files directly and encouraging them to share links instead.`}>
					<Checkbox
						label={'Prevent file attachments (link only)'}
						defaultChecked={state.settings.outlookPreventAttachments}
						onChange={(e, checked) => { state.updateOutlookPreventAttachments(!!checked); }}
					/>
				</InfoTooltipLabel>

			</PivotItem>
		</Pivot>
		

		<Stack horizontal style={{marginTop:10}}>
			<DefaultButton disabled={!state.emailFilingChangesMade} onClick={() => state.saveEmailFilingChanges()}>Apply email filing changes</DefaultButton>
		</Stack>

		</Stack>
	);
}


export default observer(EmailFilingAdminPage);
